// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { CollateralV2 } from './module';
import { routes } from './routes';

const root = {
  path: 'collateralV2',
  element: <CollateralV2 />,
  children: routes,
};

export default root;
